export const DEVICE_TYPE_WEB = "web";
export const DEVICE_TYPE_MOBILE = "mobile";
export const DEVICE_TYPE_TABLET = "tablet";
